<template>
	<aside class="alerts">
		<div class="alert" :class="`alert--${alert.type}`"
		     v-for="alert in alertsStore.alerts" :key="alert.id"
		     @click.prevent="alertsStore.remove(alert)"
		>
			{{ alert.message}}
		</div>
	</aside>
</template>
<script lang="ts" setup>
import "./Alerts.scss";
import {useAlertsStore} from "@/stores/alertsStore";

let alertsStore = useAlertsStore();

</script>